export default "__VITE_ASSET__de353188__"